module.exports = __webpack_public_path__ + "a60529b77c62cf996b648a253d618239.pdf";